<template>
  <div ref="container">
    <a-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:15%;height:50%;">
      <template slot="footer">
        <a-button type="primary" @click="handleOk">
          保存
        </a-button>
        <a-button key="back" @click="handleCancel">
          关闭
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-row class="form-row" :gutter="24">
            <a-col :span="24/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="包装规格">
                <a-select v-model="form.packageSpecification" style="width: 100%;" @change="getDIInfo">
                  <a-select-option v-for="(item,index) in specList" :key="index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
                <!-- <a-select disabled v-model="form.packageSpecification" style="width: 100%;" v-show="false">
                  <a-select-option v-for="(item,index) in specList" :key="index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
                <span v-show="form.packageSpecification ? true : false">{{ form.packageSpecification }}级包装</span> -->
              </a-form-model-item>
            </a-col>
            <!--  v-show="this.codeType == 2 && !form.edit" -->
            <a-col :span="24/1">

              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编码生成方式" name="gs1Code" v-show="!form.edit" >
                <a-radio-group v-model="form.ifSelfGs1">
                  <a-radio value="0">自动生成</a-radio>
                  <a-radio value="1">手动录入</a-radio>
                </a-radio-group>

              </a-form-model-item>
              <!--  v-if="form.ifSelfGs1 == '1'"  -->
              <a-form-model-item v-if="form.ifSelfGs1 == '1' || form.ifSelfGs1 == '0' && form.id " :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编码" name="gs1Code" prop="gs1Code">
                <a-input style="width:90%" :disabled="form.id==null? false : true" placeholder="请输入产品编码" v-model="form.gs1Code" />
                <!-- a-input   里面的:disabled="(form.totalCodeSystem.includes('2') && form.id==null)? false : true" -->
                <a-tooltip placement="right" title="产品编码填写内容不含包装规格">
                  <a-icon type="question-circle" style="margin-left:10px" />
                </a-tooltip>
              </a-form-model-item>
            </a-col>
            <a-col :span="24/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品包装单位">
                <!-- :data-source="filteredOptions" -->
                <a-auto-complete
                  placeholder="请选择产品包装级别"
                  v-model="form.packageUnit"
                  style="width: 100%;"
                  @search="handleSearch"
                  @select="handleSelect"
                >
                </a-auto-complete>
              </a-form-model-item>
            </a-col>
            <a-col :span="24/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本级包装内包含小一级相同产品标识的包装数量" name="packageNumber" prop="packageNumber">
                <a-input v-model="form.packageNumber" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="包装内含小一级包装产品标识">
                <!-- <span>{{form.productDi}}</span> -->
                <!-- <a-select disabled v-model="form.productDi" style="width: 100%;" v-show="false">
                  <a-select-option v-for="(item,index) in productDiList" :key="index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select> -->
                <a-select v-model="form.productDiMin" ref="productDiSelect" :loading="confirmLoading" option-filter-prop="children">
                  <a-select-option v-for="item in productDiList" :key="item" :value="item">{{ item }}</a-select-option>
              </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import { insertPackage, checkSupplier, updatePackage, getSpecification, getRelativeDis } from '@/api/api'
import { autoJumpNextInput } from '@/utils/util'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  name: 'VendorModal',
  mixins: [JeecgListMixin, mixinDevice],
  data() {
    return {
      // rules:{
        
      // },
      title: '333',
      codeSystem:'',
      codeType: '',
      visible: false,
      fileList: [],
      model: {},
      headers: { 'X-Access-Token': '123' },
      isReadOnly: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
      confirmLoading: false,
      form: {
        packageSpecification: '0',
        packageNumber: undefined,
        packageLevel: undefined,
        productDi: '',
        packageUnit: '',
        productId: '',
        totalCodeSystem:[],
        gs1Code:'',
        codeSystem:'',
        ifSelfGs1:'0',
        productDiMin: ''
      },
      specList: [
        // {
        //   // 包装规格
        //   label: '初级包装',
        //   value: '0',
        // },
        {
          label: '一级包装',
          value: '0',
        },
        {
          label: '二级包装',
          value: '1',
        },
        // {
        //   label: '三级包装',
        //   value: '2',
        // },
        // {
        //   label: '四级包装',
        //   value: '3',
        // },
        // {
        //   label: '五级包装',
        //   value: '4',
        // },
        // {
        //   label: '六级包装',
        //   value: '5',
        // },
        // {
        //   label: '七级包装',
        //   value: '6',
        // },
        // {
        //   label: '八级包装',
        //   value: '7',
        // },
        // {
        //   label: '九级包装',
        //   value: '8',
        // },
      ],
      packLevelList: [],
      filteredOptions: [], // 定义过滤后的选项
      productDiList: [],
      isEdit: false,
      rules: {
        gs1Code: [
          { 
            required: true, 
            message: '产品编码不能为空!' 
          },
          {
            // validator:this.validateGs1code
            validator: (rule, value, callback) => {
              if (!this.form.id) {
                this.validateGs1code(rule, value, callback);
              } else {
                callback();
              }
            }
          }
        ],
        packageNumber: [
          {
            required: false,
            message: '请输入正整数' 
          },
          {
            validator:this.checkPackageNumber
          }
        ],
      }
      // productDi: '',
    }
  },
  created() {
    this.filteredOptions = this.packLevelList.map(item => item.label);
  },
  methods: {
    
    handleSearch(inputValue) {
      if (inputValue) {
        this.filteredOptions = this.packLevelList
          .filter(option => option.label.toLowerCase().includes(inputValue.toLowerCase()))
          .map(item => item.label);
      } else {
        this.filteredOptions = this.packLevelList.map(item => item.label);
      }
    },
    handleSelect(value) {
      this.form.packageLevel = value;
    },
    validateGs1code(rule, value, callback){
      if( this.codeType === '1' ){
        callback()
      } else if( this.codeType === '2' ) {
        if (value && value.length !== 13) {
          callback('GS1产品编码长度不正确');
        } else {
          callback();
        }
      }
    },
    checkPackageNumber(rule, value, callback){
      if (!value) {
        // 如果值为空，则不进行验证，直接通过
        callback();
      } else if (!/^[1-9][0-9]*$/.test(value)) {
          // 检查是否为正整数
          return callback(new Error('请输入正整数'));
      } else {
          // 验证通过
          callback();
      }
    },
    resetForm() {
      this.form = {
        packageSpecification: '0',
        packageNumber: undefined,
        packageLevel: undefined,
        productId: '',
        productDi: '',
        totalCodeSystem:[],
        gs1Code:'',
        codeSystem:'',
        ifSelfGs1:'0'
      }
    },
    async add(params) {
      // 增加等待弹窗渲染
      await this.$nextTick()
      // 重置表单后立即初始化列表
      this.productDiList = []

      this.codeType = params.codeSystem
      console.log(params,this.codeType,'看看添加包装传过来的编码类型是MA还是GSI')
      this.edit({})
      this.resetForm()
      if (params) {
        this.form.productId = params.id
        this.form.codeSystem = params.codeSystem
        const res = await getSpecification({ productId: params.id,codeSystem: params.codeSystem })
        
        console.log(res, 'res123')
        if (res.errno == 200 && res.errmsg == '成功') {
          const packageLevels = Number(res.data.specificationCode) - 1
          this.form.packageSpecification = packageLevels.toString()
          // this.form.productDi = res.data.minSpecificationId
          this.productDiList = res.data.minSpecificationId
          this.form.totalCodeSystem=res.data.totalCodeSystem
          this.form.codeSystem = params.codeSystem;
          this.getDIInfo(this.form.packageSpecification)
        } else {
          this.$message.error(res.data || res.msg)
        }
      }
    },
    // 获取包装信息
    async getDIInfo(value){
      this.form.packageLevel = Number(value) + 1
      this.productDiList = []
      const params = {
        productId: this.form.productId,
        codeSystem: this.form.codeSystem,
        packageLevel: value,
      }
      const res = await getRelativeDis(params)
      console.log('获取的包装信息====================',res)
      if( res.code === 200 && res.success === true ){
        if( res.result.length !== 0 ){
          // 更新列表数据
          this.productDiList = res.result.map(item => String(item.productDi))
          this.$set(this.form, 'productDiMin', String(res.result[0].productDi))
          console.log(this.form.productDiMin,'这个值=====================================')
        } else {
          this.form.productDiMin = ''
        }

      } else {
        this.$message.error(res.message)
      }
    },
    edit(record) {
      this.visible = true
      this.form = Object.assign(this.form, record)
      this.isEdit = true
      console.log(this.form,'编辑包装级别显示内容================================')
      if (this.form.hasOwnProperty('packageLevel')) {
        this.form.packageLevel = this.form.packageLevel - 1
        this.form.packageSpecification = this.form.packageLevel.toString()
      }
      if (this.form.hasOwnProperty('gs1Code')) {
        this.form.gs1Code = this.form.productDi
      }
      console.log(this.form,'this.form==================================')
      this.form.edit = true
      this.$nextTick(() => {})
    },

    close() {
      this.$emit('close')
      this.visible = false
    },
    async handleOk() {
      
      this.$refs['form'].validate((err, values) => {
        console.log(err,'err的原因=====================')
        if (err) {
          if (this.form.id) {
            
            // if (this.form.hasOwnProperty('productDi')) {
            //   this.form.productDi = this.form.productDi
            // }
            updatePackage(this.form).then(res=>{
              if (res.errno == 200 && res.errmsg == '成功') {
                this.$message.success('修改成功')
                this.isEdit = false
                this.close()
              } else {
                this.$message.error(res.errmsg)
              }
            })
          } else {
            insertPackage(this.form).then(res=>{
              console.log(res, 'res')
              if (res.errno == 200 && res.errmsg == '成功') {
                this.$message.success('添加成功')
                this.isEdit = false
                this.close()
              } else {
                this.$message.error(res.errmsg)
              }
            })
          }
        }
      })
    },
    handleCancel() {
      this.close()
    },
    validateSupplierName(rule, value, callback) {
      let params = {
        name: value,
        type: '供应商',
        id: this.model.id ? this.model.id : 0,
      }
      checkSupplier(params).then((res) => {
        if (res && res.code === 200) {
          if (!res.data.status) {
            callback()
          } else {
            callback('名称已经存在')
          }
        } else {
          callback(res.data)
        }
      })
    },
  },
}
</script>
<style scoped>
</style>